import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, ChangeDetectorRef, EventEmitter, Output, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { ClientService, TimeconversionService } from '@fitness-force/api';
import { ClientStatus } from '@fitness-force/enum';
import { CLientReferral, ClientById, ClientCoupon, ClientInteraction, TENANTSINTERFACE } from '@fitness-force/models';
import { TransactionTabComponent, SubscriptionListComponent, ClientMigrationTabComponent, RouteStateService, ClientFitnessTabComponent } from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { STAFF_STATE, STAGE_MASTER_STATE, TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { ClientBookingTabComponent } from 'libs/shared/src/lib/components/client-profile/client-booking-tab/client-booking-tab.component';
import { ClientInteractionTabComponent } from 'libs/shared/src/lib/components/client-profile/client-interaction-tab/client-interaction-tab.component';
import { ClientTrialTabComponent } from 'libs/shared/src/lib/components/client-profile/client-trial-tab/client-trial-tab.component';
import { ClientTaskTabComponent } from 'libs/shared/src/lib/components/client-profile/client-task-tab/client-task-tab.component';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject, Observable, Subject, combineLatest } from 'rxjs';
import { ClientProfileLeftSideComponent } from '../client-profile-left-side/client-profile-left-side.component';
import { ClientOverviewTabComponent } from '../client-overview-tab/client-overview-tab.component';
import { ClientProfileDetailsTabComponent } from '../client-profile-details-tab/client-profile-details-tab.component';
import { ClientCheckinTabComponent } from '../client-checkin-tab/client-checkin-tab.component';
import Statsig from 'statsig-js';

@Component({
  selector: 'client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [    CommonModule,
    AvatarModule,
    TagModule,
    StyleClassModule,
    DialogModule,
    BlockUIModule,
    MessageModule,
    TransactionTabComponent,
    SubscriptionListComponent,
    ClientInteractionTabComponent,
    ClientTrialTabComponent,
    ClientBookingTabComponent,
    ClientMigrationTabComponent,
    ClientTaskTabComponent,
    ClientOverviewTabComponent,
    TooltipModule,
    SkeletonModule,
    TabsModule,
    ClientProfileLeftSideComponent,
    ClientProfileDetailsTabComponent,
    ClientCheckinTabComponent,
    ClientFitnessTabComponent,
    TranslateModule
  ]
})
export class ClientProfileComponent implements OnInit,OnChanges, OnDestroy {
  @Input() activeTab = 'overview';
  @Input() clientId = 0;
  @Input() interactionId: number = 0;
  @Output() closeClientSidebar: EventEmitter<boolean> = new EventEmitter();

  activeIndex: number = 1;
  clientOverviewTabs: any[];

  constructor(
    private store: Store,
    private clientService: ClientService,
    public changeDetectorRef: ChangeDetectorRef,
    public translate: TranslateService,
    public datepipe: DatePipe,
    public timeService: TimeconversionService,
    public storeService: RouteStateService,

  ) {

    this.clientOverviewTabs = [
      {title: 'CLIENTSUMMARY', icon: '', key: 'clientsummary' },
      {title: 'OVERVIEW', icon: '', key: 'overview' },
      {title: 'ACTIVITY_FEED', icon: '', key: 'activity_feed' },
      {title: 'BOOKING', icon: '', key: 'booking' },
      {title: 'SUBSCRIPTIONS', icon: '', key: 'subscriptions' },
      {title: 'TRANSACTIONS', icon: '', key: 'transactions' },
      {title: 'TRIAL', icon: '', key: 'trial' },
      {title: 'TASK', icon: '', key: 'task' },
      {title: 'CHECK_IN', icon: '', key: 'check_in' },
     // {title: 'FITNESS', icon: '', key: 'fitness' },
      // {title: 'MIGRATION', icon: 'fa fa-server' },
      ];
  }

  showClientSidebar: boolean = true;
  //my code
  selectedMenu: any;
  getAccessTenantList$: Observable<any> | any | null;
  allTenants: any = [];
  tenantId = 0;
  allStaffs: any = [];
  stageMaster$: Observable<any> = new Subject();
  client: ClientById | undefined;
  clientIds: number[] = [];
  allClients$ = new BehaviorSubject<ClientById>({} as ClientById);

  selectedTenant : any;
  isBlackListed = new BehaviorSubject<boolean>(false);
  currentTenantClient:boolean=true;
  showAddCreditButton = false;
  showOrganization = false;
  showSkeleton$ = new BehaviorSubject<boolean>(true);
  requestParams = new Map();
  clientInteractions$ = new BehaviorSubject<ClientInteraction[]>([]);
  clickfromTab = new BehaviorSubject<boolean>(true);
  showCollapsed$ = new BehaviorSubject<boolean>(true);

  reloadClientData = new BehaviorSubject<boolean>(false);
  clientReferrals$ = new BehaviorSubject<CLientReferral[]>([]);
  clientCoupons$ = new BehaviorSubject<ClientCoupon[]>([]);
  activityHeight = "53vh";
  overViewHeight = "53vh";
  clientUuid: string = '';

  ngOnInit(): void {
      if(!Statsig.checkGate("show_staff_2way_message_notifciation"))
      {
        this.activityHeight = "84vh";
        this.overViewHeight = "71vh";
      }
      if(Statsig.checkGate("enable_sahha"))
      {
        this.clientOverviewTabs.push({title: 'FITNESS', icon: '', key: 'fitness' });
      }
    this.componentInit();
    // Ensure the tab state is properly synchronized on initialization
    setTimeout(() => {
      if(this.activeTab) this.activateTab(this.activeTab);
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to the selectedOption input
    if (
      changes['clientId'] && changes['clientId'].currentValue && changes['clientId'].previousValue && 
      changes['clientId'].currentValue != changes['clientId'].previousValue
    ) {
      this.getClientData();
      this.changeDetectorRef.detectChanges();
    }
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.allTenants = tenant.all_tenant;
      this.selectedTenant = tenant.selected_tenant;
      this.requestParams.set('tenant_id', { paramName: 'tenant_id', paramValue: this.tenantId });
    });
    this.stageMaster$ = this.store.select(STAGE_MASTER_STATE);
    this.getClientData();
  }

  getClientData()
  {
    if (this.clientId) {
       this.showSkeleton$.next(true);
       this.clientIds.push(this.clientId);
       const getClientDetails$ = combineLatest([
       this.store.select(STAFF_STATE),
       this.clientService.getClientByIdNew(this.clientId),
       this.clientService.getClientReferrals(this.tenantId, this.clientId),
       this.clientService.getClientEligibleCoupons(this.tenantId, this.clientId),
     ]);

     getClientDetails$.subscribe({
       next: (res:any) => {
         this.allStaffs = res[0].staffList;
         this.client = res[1] as ClientById;
         this.clientUuid = this.client?.uuid || '';
         this.allClients$.next(this.client);
         
         if (this.client.migration_id != "" && this.client.migration_id != null) {
           this.clientOverviewTabs.push( {title: 'MIGRATION', icon: 'fa fa-server' })
         }
         if(this.client.client_status == ClientStatus.Client || this.client.client_status.toString() == ClientStatus[ClientStatus.Client])
         {
           if(this.tenantId == this.client.home_club_tenant_id) this.currentTenantClient = true;
           else this.currentTenantClient =false; 
         }
         else if(this.client.client_status == ClientStatus.Prospect || this.client.client_status.toString() == ClientStatus[ClientStatus.Prospect]
         || this.client.client_status == ClientStatus.Trial || this.client.client_status.toString() == ClientStatus[ClientStatus.Trial]){
           if(this.tenantId == this.client.createdin_tenant_id) this.currentTenantClient = true;
           else this.currentTenantClient =false; 
         }
         else {
           if(this.tenantId == this.client.createdin_tenant_id && this.tenantId == this.client.home_club_tenant_id) this.currentTenantClient = true;
           else if(this.tenantId == this.client.home_club_tenant_id) this.currentTenantClient = true;
           else this.currentTenantClient =false; 
         }
         this.clientReferrals$.next(res[2].items ? res[2].items : []);
         this.clientCoupons$.next(res[3].items ? res[3].items : []);
         this.showSkeleton$.next(false);
         this.storeService.setClient(this.client);
         this.changeDetectorRef.detectChanges();
       },
       error: (error: any) => {
         this.storeService.setClient(null);
         this.showSkeleton$.next(false);
         this.changeDetectorRef.detectChanges();
       }
     });
   }
  }

  get getAllParams(): Array<any> {
    return [...this.requestParams.values()];
  }

  activateTab(tab: string) {
    try {
      this.activeTab = tab;
      const tabIndex = this.clientOverviewTabs.findIndex(m => m.key.toLowerCase() === tab.toLowerCase());
      
      // Ensure activeIndex is valid
      if (tabIndex >= 0 && tabIndex < this.clientOverviewTabs.length) {
        this.activeIndex = tabIndex;
        this.selectedMenu = this.clientOverviewTabs[tabIndex];
      } else {
        console.warn(`Tab key '${tab}' not found, defaulting to index 0`);
        this.activeIndex = 0;
        this.selectedMenu = this.clientOverviewTabs[0];
      }
      
      // Ensure change detection
     // this.changeDetectorRef.markForCheck();
      //this.changeDetectorRef.detectChanges();
    } catch (error) {
      console.error('Error activating tab:', error);
      // Default to first tab in case of error
      this.activeIndex = 0;
      this.changeDetectorRef.detectChanges();
    }
  }

  get showSkeleton(): boolean {
    return this.showSkeleton$.getValue();
  }

  closeSidebar(event:any)
  {
    this.showClientSidebar= false;
    this.closeClientSidebar.emit(true);
  }

  changeTabClick(event:any)
  {
    if(event.changeTab){
      this.showSkeleton$.next(true);
      this.clickfromTab.next(true);
      this.showCollapsed$.next(false);
      this.activateTab(event.tabName);
    }
      
  }

  changeEvent(e: any) {
    if(e) this.getClientDetails();
  }

  getClientDetails() {
    this.showSkeleton$.next(true);
    this.clientService.getClientByIdNew(this.clientId).subscribe({
      next: (res) => {
        this.client = res;
        this.clientUuid = this.client?.uuid || '';
        this.allClients$.next(this.client);
        this.showSkeleton$.next(false);
        this.changeDetectorRef.detectChanges();
      },
      error: (error: any) => {
        this.showSkeleton$.next(false);
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  getClientEligibleCoupon() {
    this.showSkeleton$.next(true);
    this.clientService.getClientEligibleCoupons(this.tenantId, this.clientId).subscribe({
      next: (res) => {
        this.clientCoupons$.next(res.items ? res.items : []);
        this.showSkeleton$.next(false);
        this.changeDetectorRef.detectChanges();
      },
      error: (error: any) => {
        this.showSkeleton$.next(false);
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  updateData(event:boolean)
  {
    if(event){
      this.reloadClientData.next(true);
      setTimeout(() => {
        this.getClientDetails();
      }, 1000);
      this.changeDetectorRef.detectChanges();
    } 
  }

  reloadData(event:any)
  {
     if(event.relaodData) this.getClientEligibleCoupon();
  }

  ngOnDestroy(): void {
    // Complete BehaviorSubjects instead of unsubscribing
    if (this.showSkeleton$) {
      this.showSkeleton$.complete();
    }
    if (this.allClients$) {
      this.allClients$.complete();
    }
    if (this.isBlackListed) {
      this.isBlackListed.complete();
    }
    if (this.clientInteractions$) {
      this.clientInteractions$.complete();
    }
    if (this.clickfromTab) {
      this.clickfromTab.complete();
    }
    if (this.showCollapsed$) {
      this.showCollapsed$.complete();
    }
    if (this.reloadClientData) {
      this.reloadClientData.complete();
    }
    if (this.clientReferrals$) {
      this.clientReferrals$.complete();
    }
    if (this.clientCoupons$) {
      this.clientCoupons$.complete();
    }
    
    // Clear maps
    this.requestParams.clear();
  }

  onTabChange(event: any) {
    try {
      const tabIndex = parseInt(event, 10);
      if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < this.clientOverviewTabs.length) {
        // Special handling for task tab (index 7)
        // if (tabIndex === 7) {
        //   console.log('Task tab selected - using special handling');
          
        //   // Set the activeIndex first
        //   this.activeIndex = tabIndex;
        //   this.changeDetectorRef.detectChanges();
          
        //   // Then update the menu state after a small delay
        //   setTimeout(() => {
        //     this.activeTab = this.clientOverviewTabs[tabIndex].key;
        //     this.selectedMenu = this.clientOverviewTabs[tabIndex];
        //     this.changeDetectorRef.detectChanges();
        //   }, 10);
        // } else {
          // Normal handling for other tabs
          this.activeIndex = tabIndex;
          this.activeTab = this.clientOverviewTabs[tabIndex].key;
          this.selectedMenu = this.clientOverviewTabs[tabIndex];
        //}
        
        console.log(`Tab changed to: ${this.activeTab} (index: ${this.activeIndex})`);
      }
    } catch (error) {
      console.error('Error during tab change:', error);
    }
  }
}